const request = require('@/utils/request');
const token = require('../utils/token');
const router = require('../router');

const beforeApi = (options, method) => {
    init(options, method);
    return new Promise((resolve, reject) => {
        console.log('options.auth', options.auth);
        if (options.auth && token.isNeedRefresh()) {
            V.$api.auth.refresh().then(r => {
                request.default.request(options).then(resolve).catch(reject);
            }).catch(r => {
                //清缓存，跳转登录页
                token.clear();
                //跳转
                V.alertError("授权失败，重新登录");
                V.endLoad();
                router.default.push("/login");
            });
        } else 
        {
            request.default.request(options).then(resolve).catch(r => {
                if (r != undefined && r.Status == -2) {
                    //清缓存，跳转登录页
                    token.clear();
                    //跳转
                    V.alertError("授权失败，重新登录");
                    V.endLoad();
                    router.default.push("/login");
                }
                else {
                    reject(r);
                }
            });
        }
        // request.default.request(options).then(resolve).catch(r => {
        //     if (r != undefined && r.Status == -2) {
        //         //清缓存，跳转登录页
        //         token.clear();
        //         //跳转
        //         V.alertError("授权失败，重新登录");
        //         V.endLoad();
        //         router.default.push("/login");
        //     }
        //     else {
        //         reject(r);
        //     }
        // });
    });
}

const Post = options => beforeApi(options, "post");

const Get = options => beforeApi(options, "get");

const Put = options => beforeApi(options, "put");

const Delete = options => beforeApi(options, "delete");

const init = (options, method) => {
    options = options || {};
    options.method = method;
    //默认需要权限验证
    if (options.auth == undefined) {
        options.auth = true;
    }
    // //默认需要loading
    // if (options.loading == undefined) {
    //     options.loading = true;
    // }
}

module.exports = {
    request: request.default.request,
    post: Post,
    put: Put,
    get: Get,
    delete: Delete
}